import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-faq {
  padding: 32px 0 20px;
  background: #222222;
}

#partiu-gp-faq .faq-titulo {
  margin: 0 0 24px;
  color: #fff;
  font-family: 'SantanderHeadline';
  font-size: 32px;
  font-weight: 800;
  line-height: 36px;
}

#partiu-gp-faq .faq-lista {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

#partiu-gp-faq .custom-accordion {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}

#partiu-gp-faq .custom-accordion .acc-header {
  background-color: #fff;
  border-bottom: none;
  min-height: auto;
  padding: 16px 24px;
}

#partiu-gp-faq .custom-accordion.opened .acc-header {
  background-color: #fff;
  border-bottom: none;
}

#partiu-gp-faq .custom-accordion .acc-header .acc-title {
  color: #222222;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  font-weight: 800;
  line-height: 22px;
}

#partiu-gp-faq .custom-accordion .acc-header .acc-btn img {
  display: none;
}

#partiu-gp-faq .custom-accordion .acc-header .acc-btn {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  position: relative;
}

#partiu-gp-faq .custom-accordion .acc-header .acc-btn::before {
  content: '';
  position: absolute;
  top: 45%;
  left: 50%;
  width: 8px;
  height: 8px;
  border-right: 2px solid #222222;
  border-bottom: 2px solid #222222;
  transform: translate(-50%, -50%) rotate(45deg);
}

#partiu-gp-faq .custom-accordion .acc-body {
  border-bottom: none;
  padding: 0 24px;
}

#partiu-gp-faq .custom-accordion.opened .acc-body {
  border-bottom: none;
  padding: 0 24px 16px;
}

#partiu-gp-faq .custom-accordion .acc-body.default p,
#partiu-gp-faq .custom-accordion .acc-body.default ul,
#partiu-gp-faq .custom-accordion .acc-body.default ol {
  margin: 0;
  max-width: none;
  color: #444444;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

#partiu-gp-faq .custom-accordion .acc-body.default p + p,
#partiu-gp-faq .custom-accordion .acc-body.default ul,
#partiu-gp-faq .custom-accordion .acc-body.default ol,
#partiu-gp-faq .custom-accordion .acc-body.default * + p {
  margin-top: 12px;
}

#partiu-gp-faq .custom-accordion .acc-body.default ul,
#partiu-gp-faq .custom-accordion .acc-body.default ol {
  padding-left: 20px;
}

#partiu-gp-faq .custom-accordion .acc-body.default ul {
  list-style-type: disc;
}

#partiu-gp-faq .custom-accordion .acc-body.default ol {
  list-style-type: decimal;
}

#partiu-gp-faq .custom-accordion .acc-body.default li {
  display: list-item;
}

#partiu-gp-faq .custom-accordion .acc-body.default li + li {
  margin-top: 4px;
}

#partiu-gp-faq .custom-accordion .acc-body.default a {
  color: #127277;
  text-decoration: underline;
  word-break: break-word;
}

#partiu-gp-faq .faq-toggle {
  align-self: flex-start;
  margin-top: 4px;
  padding: 0;
  border: none;
  background: none;
  color: #fff;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

@media (min-width: 992px) {
  #partiu-gp-faq {
    padding: 56px 0 50px;
  }

  #partiu-gp-faq .faq-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 24px;
  }

  #partiu-gp-faq .faq-titulo {
    font-size: 60px;
    line-height: 66px;
    margin-bottom: 0;
    flex: 0 0 380px;
  }

  #partiu-gp-faq .faq-lista {
    flex: 1;
    gap: 4px;
  }
}
`;

export default styles;